import { render } from "./TextImage.vue?vue&type=template&id=214353a6"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"

import "./TextImage.vue?vue&type=style&index=0&id=214353a6&lang=scss"
script.render = render

export default script